"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * Outputs the Image. The component is responsive, and the
 * text portion of the image is hidden at smaller resolutions.
 */
exports.ResponsiveWindowImage = function (props) {
    return (React.createElement(ResponsiveImageContainer, { breakWidth: props.breakWidth, width: props.skinnyWidth, height: props.height },
        React.createElement("img", { src: props.src, width: props.wideWidth, height: props.height, alt: props.alt })));
};
var ResponsiveImageContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    img {\n        display: block;\n    }\n    @media (max-width: ", ") {\n        width: ", ";\n        height: ", ";\n        overflow: hidden;\n    }\n"], ["\n    img {\n        display: block;\n    }\n    @media (max-width: ", ") {\n        width: ", ";\n        height: ", ";\n        overflow: hidden;\n    }\n"])), function (_a) {
    var theme = _a.theme, breakWidth = _a.breakWidth;
    return breakWidth || theme.breakpoints.sm;
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
});
var templateObject_1;
//# sourceMappingURL=ResponsiveWindowImage.js.map